<template>
    <span class="icon">
        <i v-if="name === 'activities'" class="fa-light fa-book-open" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'add'" class="fa-light fa-circle-plus" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'bars'" class="fa-light fa-bars" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'birthday'" class="fa-light fa-cake-candles" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'care'" class="fa-light fa-hands-holding-heart" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'care-prio-normal'" class="fa-light fa-heart" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'care-prio-normal-solid'" class="fa-solid fa-heart" :style="{fontSize: fontSize}"></i>
<!--        <i v-else-if="name === 'care-prio-high'" class="fa-light fa-heart-circle-exclamation" :style="{fontSize: fontSize}"></i>-->
        <i v-else-if="name === 'care-prio-high'" class="fa-solid fa-heart-circle-exclamation" :style="{fontSize: fontSize}" style="color: #ff594f;"></i>
        <i v-else-if="name === 'chat'" class="fa-light fa-message" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'check'" class="fa-light fa-check" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'child'" class="fa-light fa-user" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'child-list'" class="fa-light fa-square-list" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'child-list-solid'" class="fa-solid fa-square-list" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'childtrackingsystem'" class="fa-light fa-chart-user" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'close'" class="fa-light fa-xmark" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'comment-add'" class="fa-light fa-comment-plus" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'comment-delete'" class="fa-light fa-comment-xmark" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'comment-save'" class="fa-light fa-comment-check" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'comments'" class="fa-light fa-comments" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'dashboard'" class="fa-light fa-grid-2" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'delete'" class="fa-light fa-trash-can" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'download'" class="fa-light fa-download" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'edit'" class="fa-light fa-pen-to-square" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'employee'" class="fa-light fa-users-line" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'file-add'" class="fa-light fa-file-plus" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'file-contract'" class="fa-light fa-file-contract" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'file-pdf'" class="fa-light fa-file-pdf" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'filter'" class="fa-light fa-filter" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'filter-solid'" class="fa-solid fa-filter" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'hours-registration'" class="fa-light fa-user-clock" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'info'" class="fa-light fa-circle-info" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'loading'" class="fa-regular fa-circle-notch fa-spin" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'logout'" class="fa-light fa-arrow-right-from-bracket" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'look-into'" class="fa-light fa-eye" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'parent-contact'" class="fa-light fa-people-arrows" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'photos'" class="fa-light fa-camera" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'photos-none'" class="fa-light fa-camera-slash" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'photos-none-solid'" class="fa-solid fa-camera-slash" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'planning'" class="fa-light fa-calendar" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'planning-edit'" class="fa-light fa-calendar-pen" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'reminder'" class="fa-light fa-bell" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'switch'" class="fa-light fa-arrow-right-arrow-left" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'shared'" class="fa-light fa-link" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'transfer'" class="fa-light fa-books" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'upload'" class="fa-light fa-upload" :style="{fontSize: fontSize}"></i>
        <i v-else-if="name === 'mail'" class="fa-light fa-envelope" :style="{fontSize: fontSize}"></i>
    </span>
</template>

<script>
export default {
    name: 'icon',
    props: {
        name,
        fontSize: {
            type: String,
            default: '2rem'
        }
    }
}
</script>

<style scoped>
i {
    cursor: pointer;
}
</style>
